import React from 'react'
import { MetaTags } from 'react-meta-tags'
import { META_DESCRIPTION, SECONDARY_COLOR } from '../../../../utils/constants'
import {Button, Card, Col, Layout, Result, Row, Space, Typography} from 'antd'
import {CheckCircleOutlined, DollarOutlined, CreditCardOutlined} from '@ant-design/icons'
import ROUTES from '../../../../utils/routes'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { ApiBaseHelper } from '../../../../utils/api-base-helper'
import { updateTech } from '../../../../redux/reducers/app'
import { useHistory } from 'react-router-dom'

const {Content} = Layout
const { Text} = Typography

const StripeSuccess = () => {
    const tech = useSelector((state) => state.tech)
    const dispatch = useDispatch()
    const history = useHistory()

    if(!tech){
        history.push(ROUTES.DASHBOARD)
    }

    useEffect( async () => {
        try {
            let stripeConnect = await ApiBaseHelper.get({
                url: "stripe/connect-url/" + tech?.Stripe_Connect_Id,
                headers: {
                    Authorization: 'Bearer ' + tech?.token
                }
            });

            let techProfile = {
                ...tech,
                'Stripe_Connect_URL': stripeConnect.data.data.url,
                'Stripe_Connected': stripeConnect.data.data.connected
            };
            dispatch(updateTech(techProfile))
        } catch (error) {
            console.error('Error generating new account link:', error)
        }
    }, [])

    return (
        <>
            <MetaTags>
                <title>Stripe Setup Complete | TecMe</title>
                <meta name="description" content={META_DESCRIPTION}/>
                <meta name="robots" content="noindex, nofollow"/>
            </MetaTags>
            <Content className="main">
                <div className="page">
                    <div>
                        <div className='auth-container'>
                            <div className='auth-page-ctn' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '85vh' }}>
                                <Row justify="center" style={{ width: '100%' }}>
                                    <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                                        <Card>
                                            <Result
                                                status="success"
                                                title="Stripe Setup Complete!"
                                                subTitle="Congratulations! Your Stripe account has been successfully connected and verified."
                                                extra={[
                                                    <Space direction="vertical" size="large" key="actions" style={{ width: '100%' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                                            <Space direction="vertical" size="middle">
                                                                <Text type="secondary">
                                                                    You can now start receiving payments from your customers securely through Stripe.
                                                                </Text>
                                                                <Space size="large" wrap>
                                                                    <Space direction="vertical" align="center" size="small">
                                                                        <CreditCardOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
                                                                        <Text style={{ fontSize: '12px' }}>Secure Payments</Text>
                                                                    </Space>
                                                                    <Space direction="vertical" align="center" size="small">
                                                                        <DollarOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
                                                                        <Text style={{ fontSize: '12px' }}>Instant Processing</Text>
                                                                    </Space>
                                                                    <Space direction="vertical" align="center" size="small">
                                                                        <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
                                                                        <Text style={{ fontSize: '12px' }}>Verified Account</Text>
                                                                    </Space>
                                                                </Space>
                                                            </Space>
                                                        </div>                                                
                                                        <Space size="middle" wrap>
                                                            <Button 
                                                                type="primary" 
                                                                size="large"
                                                                href={ROUTES.DASHBOARD}
                                                            >
                                                                Go to Dashboard
                                                            </Button>
                                                        </Space>    
                                                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                                            <Text type="secondary" style={{ fontSize: '14px' }}>
                                                                Need help? Contact our support team or visit our 
                                                                <a href="https://help.tecme.io/" target="_blank" style={{ color:SECONDARY_COLOR, marginLeft: '4px'}}>
                                                                    help center
                                                                </a>
                                                            </Text>
                                                        </div>
                                                    </Space>
                                                ]}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div> 
            </Content>
        </>
    )
}

export default StripeSuccess